import * as ko from 'knockout';
import {IDialogOptions} from '../../../dialog/index';
import {ButtonManager} from '../../../../util/ButtonManager';
import {getCancelButton, getSubmitButton} from '../../../../constants/RouteDefinitions';
import {IObjectData} from '../../../../index';
import {KOSubscriptionTracker} from '../../../../util/KOSubscriptionTracker';
import pick_groupsHtml from './pick-groups.html?raw';

export const template = pick_groupsHtml;

interface IParams {
    dialog: IDialogOptions;
    excludedGroupIds: number[];
    onAdd: (groups: IObjectData[]) => void;
}

/** Dialog: multi-select groups to add under "join group" on a collection permission. */
export class viewModel {
    readonly selectedObjects = ko.observableArray<IObjectData>([]);
    readonly pageButtons = new ButtonManager();
    readonly excludedGroupIds: number[];
    private readonly kosub = new KOSubscriptionTracker();

    constructor(private readonly params: IParams) {
        this.excludedGroupIds = params.excludedGroupIds ?? [];
        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.()));
        this.pageButtons.add(getSubmitButton({
            label: 'add',
            icon: 'fa-plus',
            cssClass: 'primary action',
            onClick: () => this.onAddClick(),
            enabled: () => !!this.selectedObjects().length,
        }));
        this.kosub.subscribe(this.selectedObjects, () => this.pageButtons.buttons?.valueHasMutated?.());
    }

    private onAddClick(): void {
        const groups = this.selectedObjects();
        if (!groups.length) {
            return;
        }
        this.params.onAdd(groups);
        this.params.dialog.doClose?.();
    }

    dispose(): void {
        this.kosub.unsuscribeAll();
    }
}
